import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonLabel,
    IonPage,
    IonRow,
    IonSegment,
    IonSegmentButton,
    IonText,
    IonTitle,
    IonToolbar,
    isPlatform,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store/rootReducer";
import { findUserList } from "../../store/formsubmitted/actions/findUserList";
import { Toolbar } from "./components/Toolbar";
import { selectTemplateDetail } from "../../store/templateDetail/selectors/selectTemplateDetail";
import { UserSelector } from "./components/UserSelector";
import { UserSelected } from "./components/UserSelected";
import { findAssignedUsers } from "../../store/formsubmitted/actions/findAssignedUsers";
import { AssignUsersStatus } from "./components/AssignUsersStatus";
import { setInitialData } from "../../store/formsubmitted";

export const FileTemplateUsers: React.FC = () => {
    const [selectorActive, setSelectorActive] = useState<boolean>(true);
    const dispatch = useDispatch();
    const template = useSelector(selectTemplateDetail);
    const userList = useSelector((state: RootState) => state.formSubmittedSlice.userList);
    const { id }: { id: string } = useParams();

    useEffect(() => {
        dispatch(setInitialData());
        dispatch(findUserList());
        dispatch(findAssignedUsers({ formId: id }));
    }, [dispatch])

    return (
        <IonPage>
            <Toolbar />
            <IonContent fullscreen>
                <IonHeader collapse="condense" class="ion-no-border">
                    <IonToolbar>
                        <IonTitle size="large">Asignar plantas al perfil</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <section
                    className={isPlatform("desktop") ? "ion-margin" : "ion-no-margin ion-margin-vertical"}
                >
                    <IonText color="primary">
                        <h2>{template ? `${template.name}` : "Plantilla de Archivo"}</h2>
                    </IonText>
                    <IonGrid class="ion-no-margin ion-no-padding">
                        {/* Inicio - Para móviles */}
                        <IonRow className="ion-hide-md-up">
                            <IonSegment
                                value={selectorActive ? "disponibles" : "seleccionados"}
                                color="secondary"
                                style={{ maxWidth: '100%', position: 'fixed', bottom: 0, left: 0, backgroundColor: 'white', zIndex: 1000 }}
                            >
                                <IonSegmentButton value="disponibles" onClick={() => { setSelectorActive(true) }}>
                                    <IonLabel>Disponibles</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="seleccionados" onClick={() => { setSelectorActive(false) }}>
                                    <IonLabel>Seleccionados</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            <IonCol style={{ paddingLeft: 0, paddingRight: 6 }}>
                                {selectorActive ? (
                                    <UserSelector />
                                ) : (
                                    <UserSelected />
                                )}
                            </IonCol>
                            <IonFooter style={{ height: '2rem' }} className="ion-no-border">
                            </IonFooter>
                        </IonRow>
                        {/* Fin - Para móviles */}
                        {/* Inicio - para desktop */}
                        <IonRow className="ion-hide-md-down">
                            <IonGrid class="ion-no-margin ion-no-padding">
                                <IonRow>
                                    <IonCol size="6" style={{ paddingLeft: 0, paddingRight: 6 }}>
                                        <UserSelector />
                                    </IonCol>
                                    <IonCol size="6" style={{ paddingRight: 0, paddingLeft: 6 }}>
                                        <UserSelected />
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonRow>
                        {/* Fin - Para desktop */}
                    </IonGrid>
                </section>
                <AssignUsersStatus />
            </IonContent>
        </IonPage>
    );
}
